// extracted by mini-css-extract-plugin
export default {"frame":"Frame__frame___u5gAV","active":"Frame__active___F9USq"};